import React, { type FC } from "react";
import { Schema } from "~/foundation/Tracking/Schema";
import { type RouteData, type SitecoreContextValue } from "~/foundation/Jss";
import { type MenuBase, type PageBase } from "~/foundation/Multisite/generated-types";
import { type PageHeaderImageBase } from "~/foundation/SitecoreContent/generated-types";

type DefaultSchemaProps = {
	route: RouteData<PageBase & MenuBase & PageHeaderImageBase>;
	context: SitecoreContextValue;
	resolveImageUrl: (imagePath?: string) => string | null;
}

export const DefaultSchema: FC<DefaultSchemaProps> = ({ route, context, resolveImageUrl }) => {
	return (
		<Schema schema={{
			"@context": "https://schema.org",
			"@type": "WebPage",
			"@id": `${context.custom.absoluteUrl}#WebPage`,
			url: context.custom.absoluteUrl,
			name: route.fields?.metaTitle?.value || route.fields?.pageTitle?.value,
			...(route.fields?.metaDescription?.value && { description: route.fields.metaDescription.value }),
			...((resolveImageUrl(route.fields?.image?.value?.src) || resolveImageUrl(route.fields?.metaImage?.value?.src)) && { image: resolveImageUrl(route.fields?.image?.value?.src) || resolveImageUrl(route.fields?.metaImage?.value?.src) }),
			breadcrumb: {
				"@type": "BreadcrumbList",
				itemListElement: (context.custom.breadcrumbItems.items || []).slice(1).map((item, index) => ({
					"@type": "ListItem",
					position: index + 1,
					item: {
						"@id": `${item.url || context.custom.absoluteUrl}`,
						name: item.title,
					}
				}))
			},
			isPartOf: {
				"@type": "WebSite",
				"@id": `${context.custom.hostname}#WebSite`,
				url: context.custom.hostname,
				name: "Aramco",
				publisher: {
					"@type": "Corporation",
					"@id": `${context.custom.hostname}#Corporation`
				}
			}
		}} />
	);
}